<div class="flex items-center">
  <a (click)="action?.()" class="text-primary text-decoration-none cursor-pointer m-l-auto f-s-12 hover:font-medium duration-100" [ngClass]="class">
    {{ text | translate }}
  </a>
</div>
